import type { Shadows } from "@mui/material/styles";
const lightShadowList = [
  "none",
  "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  "rgba(0, 0, 0, 0.16) 0px 1px 4px",
  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  "rgba(0, 0, 0, 0.10) 0px 1px 4px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
  "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
  "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
  "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
  "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
  "rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset",
  "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
  "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
  "rgba(0, 0, 0, 0.15) 0px 3px 3px 0px",
  "rgba(0, 0, 0, 0.09) 0px 3px 12px",
  "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px",
  "rgba(0, 0, 0, 0.15) 0px 2px 8px",
  "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
  "rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset",
  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
];

const darkShadowList = [
  "none",
  "rgba(255, 255, 255, 0.2) 0px 2px 8px 0px",
  "rgba(255, 255, 255, 0.16) 0px 1px 4px",
  "rgba(180, 180, 180, 0.2) 0px 7px 29px 0px",
  "rgba(255, 255, 255, 0.2) 0px 2px 8px 0px",
  "rgba(255, 255, 255, 0.24) 0px 3px 8px",
  "rgba(255, 255, 255, 0.05) 0px 6px 24px 0px, rgba(255, 255, 255, 0.08) 0px 0px 0px 1px",
  "rgba(255, 255, 255, 0.1) 0px 4px 12px",
  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(255, 255, 255, 0.3) 0px 1px 3px -1px",
  "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(255, 255, 255, 0.3) 0px 3px 7px -3px",
  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
  "rgba(255, 255, 255, 0.16) 0px 3px 6px, rgba(255, 255, 255, 0.23) 0px 3px 6px",
  "rgba(255, 255, 255, 0.19) 0px 10px 20px, rgba(255, 255, 255, 0.23) 0px 6px 6px",
  "rgba(255, 255, 255, 0.1) 0px 4px 6px -1px, rgba(255, 255, 255, 0.06) 0px 2px 4px -1px",
  "rgba(255, 255, 255, 0.2) 0px 12px 28px 0px, rgba(255, 255, 255, 0.1) 0px 2px 4px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset",
  "rgba(255, 255, 255, 0.15) 0px 5px 15px 0px",
  "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
  "rgba(255, 255, 255, 0.15) 0px 3px 3px 0px",
  "rgba(255, 255, 255, 0.09) 0px 3px 12px",
  "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px",
  "rgba(255, 255, 255, 0.15) 0px 2px 8px",
  "rgba(255, 255, 255, 0.25) 0px 0.0625em 0.0625em, rgba(255, 255, 255, 0.25) 0px 0.125em 0.5em, rgba(0, 0, 0, 0.1) 0px 0px 0px 1px inset",
  "rgba(255, 255, 255, 0.06) 0px 2px 4px 0px inset",
  "rgba(255, 255, 255, 0.1) 0px 4px 6px -1px, rgba(255, 255, 255, 0.06) 0px 2px 4px -1px",
];

/** MUI's `shadows` is a fixed 25-length tuple, so assert the shape once here. */
export const lightShadows = lightShadowList as unknown as Shadows;
export const darkShadows = darkShadowList as unknown as Shadows;
